export class UnlockAccountViewModel {
    username: string;
    token: string;
  }
